import {
  DEFAULT_PLATFORM_FEATURE_FLAGS,
  mergeFeatureFlags,
  type PlatformFeatureFlagKey,
  type PlatformFeatureFlags,
} from '@shopgnd/shared';

let cachedFlags: PlatformFeatureFlags = DEFAULT_PLATFORM_FEATURE_FLAGS;

export function applyFeatureFlags(flags: PlatformFeatureFlags): void {
  cachedFlags = flags;
}

export function getRuntimeFeatureFlags(): PlatformFeatureFlags {
  return cachedFlags;
}

export function isRuntimeFeatureEnabled(key: PlatformFeatureFlagKey): boolean {
  return cachedFlags[key] !== false;
}

export function parseFeatureFlagsJson(raw: string | undefined | null): PlatformFeatureFlags {
  if (!raw?.trim()) return DEFAULT_PLATFORM_FEATURE_FLAGS;
  try {
    const parsed = JSON.parse(raw) as Partial<PlatformFeatureFlags>;
    if (!parsed || typeof parsed !== 'object') return DEFAULT_PLATFORM_FEATURE_FLAGS;
    return mergeFeatureFlags(parsed);
  } catch {
    return DEFAULT_PLATFORM_FEATURE_FLAGS;
  }
}

export function serializeFeatureFlags(flags: PlatformFeatureFlags): string {
  return JSON.stringify(flags, null, 2);
}
